const MIN_WIDTH = 320;
const MAX_WIDTH = 4096;
const MIN_HEIGHT = 320;
const MAX_HEIGHT = 4096;

export const constructImage = (contentType, res) => {
  let url = '';
  if (contentType === 'image/png' || contentType === 'image/jpeg') {
    const base64Icon = btoa(
      new Uint8Array(res?.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
    url = `data:${contentType};base64,${base64Icon}`;
    return url;
  }
};

export const validateImageDimensions = (file): Promise<ValidationResult> => {
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;

      const isValid =
        width >= MIN_WIDTH && width <= MAX_WIDTH && height >= MIN_HEIGHT && height <= MAX_HEIGHT;

      const result: ValidationResult = {
        isValid,
        width,
        height,
        message: '',
      };

      if (width < MIN_WIDTH || height < MIN_HEIGHT) {
        result.message =
          'Image is too small. Please upload an image at least 320px in width and height.';
      } else if (width > MAX_WIDTH || height > MAX_HEIGHT) {
        result.message =
          'Image is too large. Please upload an image no bigger than 4096px in width and height.';
      }
      URL.revokeObjectURL(url);
      resolve(result);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve({
        isValid: false,
        width: 0,
        height: 0,
        message: '',
      });
    };

    img.src = url;
  });
};
